var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQuit(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "icon_quit",
    transform: "translate(-2.26 -5.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "container",
    transform: "translate(2.26 5.192)",
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "symbol",
    transform: "rotate(90 8.881 21.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_35",
    "data-name": "\\uADF8\\uB8F9 35",
    transform: "rotate(180 7.56 6.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_290",
    "data-name": "\\uD328\\uC2A4 290",
    className: "cls-2",
    d: "m0 0 4.814 4.814L9.628 0",
    transform: "translate(0 8.424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_291",
    "data-name": "\\uD328\\uC2A4 291",
    className: "cls-2",
    d: "M0 12.035V0",
    transform: "translate(4.816)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_300",
    "data-name": "\\uD328\\uC2A4 300",
    className: "cls-2",
    d: "M-47.25 565.583v6.581a.74.74 0 0 1-.809.64h-18.382a.74.74 0 0 1-.809-.64v-6.581",
    transform: "translate(67.556 -552.414)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuit);
export default __webpack_public_path__ + "static/media/icon-quit.2a77d1fc02f87c7dc162b202de250d9e.svg";
export { ForwardRef as ReactComponent };